import * as t from 'io-ts';

export const DaemonQueueConfig = t.type({
  splitByOrgEnabled: t.boolean,
  orgsPerChunk: t.number,
  orgConcurrency: t.number,
  skipOrderBy: t.boolean,
});

/** Override types */
export type DaemonQueueConfig = t.TypeOf<typeof DaemonQueueConfig>;

/**
 * This is only used for the request enricher DaemonQueue because it's special
 */
export const RequestEnricherDaemonQueueConfig = t.intersection([
  DaemonQueueConfig,
  t.type({
    processItemConcurrency: t.number,
  }),
]);

/** Override type for request enricher */
export type RequestEnricherDaemonQueueConfig = t.TypeOf<
  typeof RequestEnricherDaemonQueueConfig
>;
